module.exports = __webpack_public_path__ + "img/ico-crime.d7ad3357.svg";